// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app_wrapper__6y7M-","page-wrapper":"app_page-wrapper__WOpkd","page":"app_page__2_Zy7","fadeIn":"app_fadeIn__2irO_"};